import CustomerData from "components/CustomerData/CustomerData";
import React, { Component } from "react";
function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
export default class CustomerDataContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      limit: 100,
      formData: {
        from_date: "",
        to_date: "",
      },
     
    };
    this.debouncedSearch = debounce(this.performSearch.bind(this), 500);
  }
  async componentDidMount() {
    this.props.getLeadsAction({
      limit: this.state.limit,
      // page: this.state.page,
    });
  }
  performSearch(searchQuery) {
    if (searchQuery) {
      this.props.getLeadsAction({
        search_term: searchQuery,
        limit: this.state.limit,
      });
      return;
     } else this.props.getLeadsAction({ limit: this.state.limit });
    
  }
  searchhandleChange = (name, value) => {
    const query = value;
    this.setState({ query });
    this.debouncedSearch(query);
  };

  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };
  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };
  handleChange = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    // this.handleFilterApiData();
    this.setState({ formData });
  };
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }
  handleFilterApiData = async () => {
    await this.props.getLeadsAction({
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
     
    });
  };
  handleReset = async () =>{
    await this.props.getLeadsAction(
     { limit: this.state.limit,}
    );
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }
  onPageChange = (page, rowsPerPage) => {
    this.setState({
      page: page,
      limit: rowsPerPage,
    });
    const payload = {
      limit: rowsPerPage,
      page: page,
    };
    this.props.getLeadsAction(payload);
  };

  render() {
    const customerData = this.props.leadsDataList.customerDetails?.reverse();
    return (
      <div>
        <CustomerData
        onPageChange={this.onPageChange}
        page={this.state.page}
        isloading={this.props.isLoading}
        limit={this.state.limit}
        totalCount={this.props.leadsDataList.totalCount}
          customer_data={customerData}
          searchhandleChange={this.searchhandleChange}
          onChange={this.handleChange}
          datePickerOpen={this.state.datePickerOpen}
          handleDatePickerOpen={this.handleDatePickerOpen}
          handleDatePickerClose={this.handleDatePickerClose}
          from_date={this.state.formData.from_date}
          to_date={this.state.formData.to_date}
          onDatePickerSub={this.onDatePickerSub}
          fromat_date_from={this.state.formData.fromat_date_from}
          fromat_date_to={this.state.formData.fromat_date_to}
          handleReset={this.handleReset}
        />
      </div>
    );
  }
}
